import { formatDate } from "../../../../common/Validations";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
 
export let colData = [
  {
    name: "CUSTOMER_REPORT",
    columns: [
      {
        name: "Customer ID",
        id:"userId",
        selector: (row) => row.userId || "--",
        sortable: true,
        width: "130px",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.userId}
            </span>
          </>
        ),
      },
      {
        name: "Customer",
        cell: (row) => (
          <>
            <span className="m-0 p-0 pt-1 fw-bold text-primary">
              {row.organisationName}
            </span>
          </>
        ),
        selector: (row) => row.organisationName,
        sortable: true,
        width: "150px",
      },

      {
        name: "Address",
        selector: (row) => row.address || "--",

        cell: (row) => (
          <div>
            <p className="m-0 p-0 pt-1 fw-bold">{row.address} </p>
            <p className="m-0 p-0 fw-bold">{row.address2} </p>
          </div>
        ),
        sortable: true,
        width: "200px",
      },
      {
        name: "Company",
        selector: (row) => row.companyCode,
        cell: (row) => (
          <>
            <span className="fw-bold text-success">{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },

      {
        name: "Sales Oficer Name",
        selector: (row) => row.salesOfficerName || "--",

        cell: (row) => (
          <div>
            <p className="m-0 p-0 pt-1 fw-bold ">{row.salesOfficerName} </p>
          </div>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Sales Officer Code",
        selector: (row) => row.salesOfficerCode || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.salesOfficerCode}{" "}
            </span>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Status",
        selector: (row) => row.status,
        sortable: true,
        cell: (row) => (
          <>
            <TableStatusField status={row.status} />
          </>
        ),
        width: "170px",
      },
    ],
  },
  {
    name: "ORDER_SCHEDULE_REPORT",
    columns: [
      {
        name: "Order",
        id: "documentNumber",
        selector: (row) => row.documentNumber,
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.documentNumber}
            </span>
          </>
        ),
        sortable: true,
        width: "120px",
      },

      {
        name: "Company",
        selector: (row) => row.companyCode,
        cell: (row) => (
          <>
            <span className="fw-bold text-success">{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Customer",
        cell: (row) => (
          <>
            <span className="m-0 p-0 pt-1 fw-bold text-primary">
              {row.customerName}
            </span>
          </>
        ),
        selector: (row) => row.customerName,
        sortable: true,
        width: "150px",
      },

      {
        name: "Created Date",
        id: "createdAt",
        selector: (row) => row.createdAt,
        cell: (row) => (
          <>
            <span className="fw-bold text-primary">{row.createdAt}</span>
          </>
        ),
        sortable: true,
        width: "130px",
      },

      {
        name: "Items",
        selector: (row) => row?.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0  fw-bold">{row?.local_id} </p>
             
            </div>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Material",
        selector: (row) => row?.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0  fw-bold">{row?.materialDescription} </p>
              <p className="m-0 p-0 pt-1  ">{row?.materialCode} </p>
            </div>
          </>
        ),
        sortable: true,
        width: "140px",
      },

      {
        name: "Qty",
        selector: (row) => row?.orderQuantityLoad,
        cell: (row) => (
          <>
            <span className="fw-bold text-primary">
              {row?.orderQuantityLoad}
            </span>
          </>
        ),
        sortable: true,
        width: "100px",
      },
      // {
      //   name: "Uom",
      //   selector: (row) => row?.uOM,
      //   cell: (row) => (
      //     <>
      //       <span className="fw-bold text-primary">{row?.uOM}</span>
      //     </>
      //   ),
      //   sortable: true,
      //   width: "100px",
      // },
      {
        name: "Unit Price",
        selector: (row) => row.unitPrice,
        cell: (row) => (
          <>
            <span className="fw-bold text-primary">{row?.unitPrice}</span>
          </>
        ),
        sortable: true,
        width: "120px",
      },
      // {
      //   name: "Basic Price",
      //   selector: (row) => row.basicPrice,
      //   cell: (row) => (
      //     <>
      //       <span className="fw-bold text-primary">{row?.basicPrice}</span>
      //     </>
      //   ),
      //   sortable: true,
      //   width: "120px",
      // },
      // {
      //   name: "Basic Amount",
      //   selector: (row) => row.basicAmount,
      //   cell: (row) => (
      //     <>
      //       <span className="fw-bold text-primary">{row?.basicAmount}</span>
      //     </>
      //   ),
      //   sortable: true,
      //   width: "120px",
      // },
      // {
      //   name: "Cgst Value",
      //   selector: (row) => row.basicAmount,
      //   cell: (row) => (
      //     <>
      //       <span className="fw-bold text-primary">{row?.basicAmount}</span>
      //     </>
      //   ),
      //   sortable: true,
      //   width: "120px",
      // },
      // {
      //   name: "Cgst Value",
      //   selector: (row) => row.cgstValue,
      //   cell: (row) => (
      //     <>
      //       <span className="fw-bold text-primary">{row?.cgstValue}</span>
      //     </>
      //   ),
      //   sortable: true,
      //   width: "120px",
      // },
      // {
      //   name: "Sgst Value",
      //   selector: (row) => row.sgstValue,
      //   cell: (row) => (
      //     <>
      //       <span className="fw-bold text-primary">{row?.sgstValue}</span>
      //     </>
      //   ),
      //   sortable: true,
      //   width: "120px",
      // },
      {
        name: "Shiping Code",
        cell: (row) => (
          <div>
            <p className="m-0 p-0 pt-1 fw-bold ">{row?.shippingPostalCode} </p>
            {/* {row?.items?.customerAddress !== row?.items?.shippingAddress && (
              <>
                <p className="m-0 p-0 pt-1 fw-bold ">
                  {row?.items?.shippingAddress}{" "}
                </p>

                <p className="m-0 p-0 pt-1 fw-bold ">
                  {row?.items?.shippingPostalCode}{" "}
                </p>
              </>
            )} */}
          </div>
        ),
        sortable: true,
        width: "150px",
      },

      {
        name: "Dispatch Date",
        selector: (row) => row.dispatchDate,
        cell: (row) => (
          <>
            <span>{row.dispatchDate}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
    ],
  },
  {
    name: "INVOICE_REPORT",
    columns: [
      {
        name: "Invoice Nr",
        id:"invoiceNr",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.invoiceNr}
            </span>
          </>
        ),
        selector: (row) => row.invoiceNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Invoice Date",
        id:"createdAt",
        selector: (row) => (
          <>
            <span className="fw-bold text-primary">
              {formatDate(row.createdAt)}
            </span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Order Nr",
        id:"orderSchedulingNr",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.orderSchedulingNr}
            </span>
          </>
        ),
        selector: (row) => row.orderSchedulingNr || "--",
        sortable: true,
        width: "130px",
      },
      {
        name: "Loading Nr",
        id:"loadingAdviceNr",
        selector: (row) => row.loadingAdviceNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.loadingAdviceNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Company Code",
        selector: (row) => row.companyCode,
        cell: (row) => (
          <>
            <span className="fw-bold text-success">{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Customer",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span className="fw-bold">{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "130px",
      },
      {
        name: "E-Way Bill",
        selector: (row) => row.e_WayBillNo || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.e_WayBillNo}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "mode",
      //   selector: (row) => row.mode || "--",
      //   cell: (row) => (
      //     <>
      //       <span /* className="bg-table-status bg-table-success-status" */>
      //         {row.mode}
      //       </span>
      //     </>
      //   ),
      //   sortable: true,
      //   width: "150px",
      // },
      {
        name: "E-Way Bill Date",
        selector: (row) => row.generatedDate || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Item id",
        selector: (row) => row.local_id,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.local_id} </p>
              {/* <p className="m-0 p-0">{row.materialDescription} </p> */}
            </div>
          </>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material",
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Qty Load Confirm ",
        selector: (row) => row.orderQtyLoadConfirm || "--",
        sortable: true,
        width: "160px",
      },
      {
        name: "UOM ",
        selector: (row) => row.uOM || "--",
        width: "100px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.unitPrice || "--",
        width: "100px",
      },
      {
        name: "Basic Price",
        selector: (row) => row.basicPrice || "--",
        width: "100px",
      },
      {
        name: "Basic Amount",
        selector: (row) => row.basicAmount || "--",
        width: "120px",
      },
      {
        name: "CGST",
        selector: (row) => row.cgstValue || "--",
        width: "100px",
      },
      {
        name: "SGST",
        selector: (row) => row.sgstValue || "--",
        width: "100px",
      },
      {
        name: "Net Value  ",
        selector: (row) => row.netValue || "--",
        width: "100px",
      },
      {
        name: "Shipping Addr",
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.shippingAddress} </p>
              <p className="m-0 p-0">{row.shippingPostalCode} </p>
            </div>
          </>
        ),
        width: "140px",
      },
    ],
  },
  {
    name: "LOADING_ADVICE_REPORT",
    columns: [
      {
        name: "Loading Nr",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.loadingAdviceNr}
            </span>
          </>
        ),
        selector: (row) => row.loadingAdviceNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Invoice Date",
        selector: (row) => (
          <>
            <span className="fw-bold text-primary">
              {formatDate(row.createdAt)}
            </span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Order Nr",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.orderSchedulingNr}
            </span>
          </>
        ),
        selector: (row) => row.orderSchedulingNr || "--",
        sortable: true,
        width: "130px",
      },

      {
        name: "Company",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span className="fw-bold text-success">{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Customer",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span className="fw-bold">{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "130px",
      },
      {
        name: "Item id",
        selector: (row) => row.local_id,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.local_id} </p>
            </div>
          </>
        ),
        width: "100px",
        sortable: true,
      },

      {
        name: "Material",
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Qty Load Confirm ",
        selector: (row) => row.orderQtyLoadConfirm || "--",
        sortable: true,
        width: "150px",
      },

      {
        name: "UOM ",
        selector: (row) => row.uOM || "--",
        width: "100px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.unitPrice || "--",
        width: "100px",
      },
      {
        name: "Shipping Addr",
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.shippingAddress} </p>
              <p className="m-0 p-0">{row.shippingPostalCode} </p>
            </div>
          </>
        ),
        width: "140px",
      },
      {
        name: "Godown Addr",
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.godownAddress} </p>
            </div>
          </>
        ),
        width: "140px",
      },
      {
        name: "Truck Nr",
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.loadingTruckNo} </p>
            </div>
          </>
        ),
        width: "140px",
      },
      {
        name: "Driver",
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.transporterDriverName} </p>
              <p className="m-0 p-0 pt-1">{row.transporterDriverContact} </p>
            </div>
          </>
        ),
        width: "140px",
      },
    ],
  },

  {
    name: "PR_REPORT",
    columns: [
      {
        name: "Company Code",
        cell: (row) => (
          <>
            <span className="m-0 p-0 pt-1 fw-bold">{row.companyCode}</span>
          </>
        ),
        selector: (row) => row.companyCode || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Pur Org",
        selector: (row) => row.purchasingOrg || "--",
        sortable: true,
        width: "120px",
      },
      {
        name: "Pur Category",
        cell: (row) => (
          <>
            <span className="m-0 p-0 pt-1 fw-bold">{row.purchaseCategory}</span>
          </>
        ),
        selector: (row) => row.purchaseCategory || "--",
        sortable: true,
        width: "130px",
      },
      {
        name: "PR Nr",
        selector: (row) => row.purchaseReqDocumentNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.purchaseReqDocumentNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "PR Date",
        selector: (row) => row.purchasingDocumentDate || "--",
        sortable: true,
        width: "150px",
      },

      {
        name: "Satus",
        selector: (row) => row.prStatusHeader || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-success-status">
              {row.prStatusHeader}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "PR Item Nr",
        selector: (row) => row.purchasingReqDocumentItemNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Quantity ",
        selector: (row) => row.purchaseQuantity || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        width: "100px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.orderPriceUnit || "--",
        width: "100px",
      },
      {
        name: "Currency",
        selector: (row) => row.currency || "--",
        width: "100px",
      },
      {
        name: "Delivery Date ",
        selector: (row) => row.deliveryDate || "--",
        width: "150px",
      },
      {
        name: "Storage Locn",
        selector: (row) => row.storageLocn || "--",
        width: "150px",
      },
    ],
  },
  {
    name: "ASN_REPORT",
    columns: [
      {
        name: "ASN Nr",
        selector: (row) => row.asnNumber || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.asnNumber}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "ASN Date",
        selector: (row) => row.purchasingDocumentDate || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "ASN Status",
        selector: (row) => row.asnStatusHeader || "--",
        sortable: true,
        width: "150px",
      },

      {
        name: "Pur Doc Nr",
        selector: (row) => row.purchasingDocumentNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-success-status">
              {row.purchasingDocumentNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Code",
        selector: (row) => row.vendorCode || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Name",
        selector: (row) => row.vendorName || "--",
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Pur Category",
      //   cell: (row) => (
      //     <>
      //       <span className="m-0 p-0 pt-1 fw-bold">{row.purchaseCategory}</span>
      //     </>
      //   ),
      //   selector: (row) => row.purchaseCategory || "--",
      //   sortable: true,
      //   width: "130px",
      // },
      {
        name: "ASN Item Nr",
        selector: (row) => row.asnItemNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: " ASN Qty ",
        selector: (row) => row.asnQuantity || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        width: "100px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.orderPriceUnit || "--",
        width: "100px",
      },
      {
        name: "Currency",
        selector: (row) => row.currency || "--",
        width: "100px",
      },
      {
        name: "Delivery Date ",
        selector: (row) => row.deliveryDate || "--",
        width: "150px",
      },
      {
        name: "Storage Locn",
        selector: (row) => row.storageLocn || "--",
        width: "150px",
      },
    ],
  },
  {
    name: "SO_INVOICE_REPORT",
    columns: [
      {
        name: "INV Nr",
        selector: (row) => row.invoiceNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.invoiceNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "INV Date",
        selector: (row) => row.invDocumentDate || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Status",
        selector: (row) => row.invoiceStatusHeader || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Code",
        selector: (row) => row.vendorCode || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Name",
        selector: (row) => row.vendorName || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Pur Doc Nr",
        selector: (row) => row.purchasingDocumentNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-success-status">
              {row.purchasingDocumentNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Pur Item Nr",
        selector: (row) => row.purchasingDocumentItemNr || "--",
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Pur Category",
      //   cell: (row) => (
      //     <>
      //       <span className="m-0 p-0 pt-1 fw-bold">{row.purchaseCategory}</span>
      //     </>
      //   ),
      //   selector: (row) => row.purchaseCategory || "--",
      //   sortable: true,
      //   width: "130px",
      // },
      {
        name: "INV Item Nr",
        selector: (row) => row.invoiceItemNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: " INV Qty ",
        selector: (row) => row.invoiceQuantity || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        width: "100px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.orderPriceUnit || "--",
        width: "100px",
      },
      {
        name: "Currency",
        selector: (row) => row.currency || "--",
        width: "100px",
      },
      {
        name: "Delivery Date ",
        selector: (row) => row.deliveryDate || "--",
        width: "150px",
      },
      {
        name: "Storage Locn",
        selector: (row) => row.storageLocn || "--",
        width: "150px",
      },
    ],
  },
  {
    name: "GRN_REPORT",
    columns: [
      {
        name: "GRN Nr",
        selector: (row) => row.grnNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.grnNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "GRN Date",
        selector: (row) => row.grnDocumentDate || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Status",
        selector: (row) => row.grnStatusHeader || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Code",
        selector: (row) => row.vendorCode || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Name",
        selector: (row) => row.vendorName || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Pur Doc Nr",
        selector: (row) => row.purchasingDocumentNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-success-status">
              {row.purchasingDocumentNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "PO Item Nr",
        selector: (row) => row.purchasingDocumentItemNr || "--",
        sortable: true,
        width: "150px",
      },

      // {
      //   name: "Pur Category",
      //   cell: (row) => (
      //     <>
      //       <span className="m-0 p-0 pt-1 fw-bold">{row.purchaseCategory}</span>
      //     </>
      //   ),
      //   selector: (row) => row.purchaseCategory || "--",
      //   sortable: true,
      //   width: "130px",
      // },
      {
        name: "GRN Item Nr",
        selector: (row) => row.grnItemNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: " GRN Qty ",
        selector: (row) => row.grnQuantity || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        width: "100px",
      },

      {
        name: "Delivery Date ",
        selector: (row) => row.deliveryDate || "--",
        width: "150px",
      },
      {
        name: "Plant",
        selector: (row) => row.plant || "--",
        width: "150px",
      },
      {
        name: "Storage Locn",
        selector: (row) => row.storageLocn || "--",
        width: "150px",
      },
      {
        name: "Mov Type",
        selector: (row) => row.movementType || "--",
        width: "150px",
      },
    ],
  },
];
